import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export const HeaderSectionBox = ({ children, className }: { children: ReactNode; className?: string }) => {
  return <div className={twMerge('rounded bg-neutral-900 p-2 flex flex-col', className)}>{children}</div>;
};

export const PageTitle = ({ children }: { children: string }) => {
  return (
    <h1 className="w-full font-secondary font-bold text-center text-white uppercase text-[28px] md:text-[44px] mb-1">
      {children}
    </h1>
  );
};

export const PageDescription = ({ children }: { children: React.ReactNode }) => {
  return <p className="font-sans text-neutral-300 text-base w-full text-center leading-[140%]">{children}</p>;
};

export const SectionTitle = ({ children, className }: { children: ReactNode; className?: string }) => {
  return (
    <h2 className={twMerge('text-sm font-semibold text-neutral-400 flex flex-row items-center gap-x-2', className)}>
      {children}
    </h2>
  );
};

export const SectionDesc = ({ children, className }: { children: ReactNode; className?: string }) => {
  return <h6 className={twMerge('text-xs font-medium uppercase', className)}>{children}</h6>;
};

export const Paragraph = ({ children }: { children: ReactNode }) => {
  return <p className="text-neutral-500 text-sm leading-relaxed">{children}</p>;
};

export const BlockTitle = ({ children, className }: { children: ReactNode; className?: string }) => {
  return <h3 className={twMerge('text-lg font-medium text-neutral-100 text-center', className)}>{children}</h3>;
};

export const BlockDesc = ({ children, className }: { children: ReactNode; className?: string }) => {
  return <p className={twMerge('text-sm text-center text-neutral-300', className)}>{children}</p>;
};
